<div class="container d-flex align-items-center justify-content-center spei-container">
  <div class="row" *ngIf="!loadingPayment; else paymentInProcess">
    <div class="col-12">
      <div class="d-flex justify-content-center">
        <div>
          <h1 class="text-center">¡Muchas gracias por tu compra!</h1>
          <h1 class="text-center" *ngIf="purchaseCode != ''">{{'Compra #'+purchaseCode}}</h1>
        </div>
      </div>
    </div>
    <div class="row  gy-2" *ngIf="urlPDF !== ''">
      <div class="col-12 col-md-12 col-lg-6 text-center text-md-center text-lg-end">
        <button (click)="openPayment()" class="button secondary-button">Abrir el recibo de pago</button>
      </div>
      <div class="col-12 col-md-12 col-lg-6 text-center text-md-center text-lg-start">
        <button (click)="exitPayment()" class="button secondary-button">Regresar al menú principal</button>
      </div>
    </div>
    <div class="row" *ngIf="urlPDF !== ''">
      <div class="col text-center">
        <h2>Compra # {{paymentPDFId}} por un total de {{ total | currency }} MXN</h2>
        <p class="text-muted">Favor de imprimir su comprobante para realizar el pago por transferencia de su compra.</p>
        <p class="text-muted">Una vez realizado el pago favor de mandar un correo electrónico a <strong>hola@aliwell.mx</strong> con una foto de su comprobante para procesar su compra</p>
      </div>
    </div>
  </div>
  <ng-template #paymentInProcess>
    <div class="row">
      <p class="fs-4 text-center">
        Espere un momento por favor, tu pago esta siendo procesado, favor de no cerrar la pestaña o el navegador.
      </p>
      <app-loading [size]="'64px'"></app-loading>
    </div>
  </ng-template>
</div>
